/* VG-61 Gripps guide (both arms): the look-closer photo and the sticky Shop bar.
   Ported from the approved preview (core.mjs explorer() and stickyCard()). No tracking here: the page's custom events
   read the data-vg-cta, data-vg-gg-look and data-vg-gg-close hooks. */
(function () {
  'use strict';

  function explorer(wrap) {
    var stage = wrap.querySelector('.gl-explore__stage');
    var base = stage && stage.querySelector('.gl-media__image');
    var zoom = stage && stage.querySelector('.gl-explore__zoom');
    if (!stage || !base || !zoom) return;
    var zoomImg = zoom.querySelector('.gl-explore__zoom-img');
    var label = zoom.querySelector('.gl-explore__label');
    var back = zoom.querySelector('.gl-explore__back');
    var pins = Array.prototype.slice.call(stage.querySelectorAll('.gl-explore__pin'));
    var chips = Array.prototype.slice.call(wrap.querySelectorAll('.gl-explore__chip'));
    var active = -1;

    function show(index) {
      active = index;
      stage.classList.toggle('is-zoomed', index >= 0);
      zoom.hidden = index < 0;
      pins.forEach(function (pin, i) { pin.setAttribute('aria-pressed', String(i === index)); });
      chips.forEach(function (chip, i) {
        chip.classList.toggle('is-active', i === index);
        chip.setAttribute('aria-pressed', String(i === index));
      });
      if (index < 0) return;
      var pin = pins[index];
      var scale = parseFloat(pin.getAttribute('data-zoom')) || 2.4;
      var shift = function (point) { return Math.min(0, Math.max(100 - scale * 100, 50 - scale * point)); };
      zoom.classList.add('gl-explore__zoom--crop');
      zoomImg.src = base.currentSrc || base.src;
      zoomImg.alt = 'Close-up of the ' + (pin.getAttribute('data-label') || '').toLowerCase() + ' on Versa Gripps Pro';
      zoomImg.style.transformOrigin = '0 0';
      zoomImg.style.transform = 'translate(' + shift(parseFloat(pin.getAttribute('data-zx'))) + '%, ' +
        shift(parseFloat(pin.getAttribute('data-zy'))) + '%) scale(' + scale + ')';
      label.textContent = '';
      var num = document.createElement('span'); num.className = 'gl-explore__num'; num.textContent = String(index + 1);
      var strong = document.createElement('strong'); strong.textContent = pin.getAttribute('data-label') || '';
      var text = document.createElement('span'); text.textContent = pin.getAttribute('data-short') || '';
      label.appendChild(num); label.appendChild(strong); label.appendChild(text);
      zoom.classList.remove('is-in'); void zoom.offsetWidth; zoom.classList.add('is-in');
    }
    function toggle(index) { show(index === active ? -1 : index); }
    pins.forEach(function (pin, i) { pin.addEventListener('click', function () { toggle(i); }); });
    chips.forEach(function (chip, i) { chip.addEventListener('click', function () { toggle(i); }); });
    if (back) back.addEventListener('click', function () { show(-1); });
  }

  function visible(el) {
    if (!el || !el.getClientRects().length) return false;
    var cs = getComputedStyle(el);
    return cs.visibility !== 'hidden' && cs.display !== 'none' && parseFloat(cs.opacity || '1') > 0.05;
  }

  function sticky(root) {
    var aside = root.querySelector('.gl-sticky');
    if (!aside) return;
    var heroLink = root.querySelector('[data-vg-cta="hero"]');
    var finalLink = root.querySelector('[data-vg-cta="final"]') || root.querySelector('.gl-close');
    var inline = Array.prototype.slice.call(root.querySelectorAll('.gl-inline-cta .gl-button'));
    var queued = false;
    function update() {
      queued = false;
      var heroGone = heroLink ? heroLink.getBoundingClientRect().bottom < 0 : window.scrollY > 250;
      var finalReached = finalLink ? finalLink.getBoundingClientRect().top < window.innerHeight : false;
      var inlineOnScreen = inline.some(function (b) {
        var r = b.getBoundingClientRect();
        return r.bottom > 0 && r.top < window.innerHeight;
      });
      var overlayOpen = document.body.classList.contains('upcartPopupShow') ||
        Array.prototype.some.call(document.querySelectorAll('[role="dialog"][aria-modal="true"]'), visible) ||
        Boolean(document.querySelector('details[open] > .menu-drawer, .menu-drawer-container[open]'));
      aside.hidden = !(heroGone && !finalReached && !inlineOnScreen && !overlayOpen);
    }
    function queue() { if (!queued) { queued = true; window.requestAnimationFrame(update); } }
    window.addEventListener('scroll', queue, { passive: true });
    window.addEventListener('resize', queue);
    document.addEventListener('click', function () { setTimeout(queue, 50); }, true);
    queue();
  }

  function init() {
    Array.prototype.forEach.call(document.querySelectorAll('.vg-gg'), function (root) {
      Array.prototype.forEach.call(root.querySelectorAll('.gl-explore'), explorer);
      sticky(root);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
